module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Hidden-46cf8d550659dcd7a558716c7888db41.svg";